import styled from 'styled-components'

export const StyledAlertModalContent = styled.div`
	text-align: center;
`

export const StyledAlertText = styled.div`
	font-size: 18px;
	font-weight: 300;
`
